import React from 'react';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('AppErrorBoundary caught an error', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-sky-50 px-4">
          <div className="max-w-md w-full text-center bg-white rounded-3xl shadow-2xl p-6 space-y-4 border border-sky-100">
            <span className="text-5xl" role="img" aria-hidden="true">
              🛠️
            </span>
            <h1 className="text-2xl font-black text-sky-700">Something fizzled out</h1>
            <p className="text-slate-600 text-sm">
              We hit an unexpected issue loading this mission. Try again in a moment.
            </p>
            <button
              type="button"
              onClick={this.handleRetry}
              className="rounded-full bg-gradient-to-r from-emerald-500 via-sky-500 to-indigo-500 text-white text-sm font-bold px-6 py-3 shadow-lg hover:shadow-xl transition-transform hover:-translate-y-1"
            >
              Back to Home Base
            </button>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default AppErrorBoundary;

